import { ANNOUNCEMENT_API_URL, fmhAPI } from 'api/APIBase';

export async function getCarouselImage({
    messageId,
    filename,
}: {
    messageId: string;
    filename: string;
}) {
    const url = `${ANNOUNCEMENT_API_URL}/home_screen/message/${messageId}/images/${filename}`;
    return fmhAPI.base
        .url(url)
        .get()
        .blob((blob) => new File([blob], filename));
}
